import { Guest } from 'shared-types/Common';
import { pathOr } from 'ramda';
import { connect } from 'react-redux';
import { getFormValues, change } from 'redux-form';
import { NormalizedStore } from '@store/entity/entity.types';
import SpaPackageExtras from './SpaPackageExtras';
import { StateProps } from './SpaPackageExtras.types';
import { SPA_PACKAGE_FORM_NAME } from '../shared';

const mapStateToProps = (state: NormalizedStore, { form }): StateProps => {
  const allFormValues = getFormValues(form)(state);
  const selectedGuests = pathOr([], ['guests'], allFormValues).map(
    ({ title, firstName, lastName, gender, id, loggedInUser }) => ({
      title,
      firstName,
      lastName,
      gender,
      ...(id && id !== loggedInUser?.id && { id }),
      loggedInUser,
    })
  ) as Guest[];

  const selectedExtras = pathOr({}, ['extras'], allFormValues);
  return { selectedGuests, selectedExtras };
};

const mapDispatchToProps = (dispatch) => ({
  resetExtras: dispatch(change(SPA_PACKAGE_FORM_NAME, 'extras', {})),
});

export const SpaPackageExtrasConnected: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(SpaPackageExtras);
